import script from "./OrderItemRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderItemRow.vue?vue&type=script&setup=true&lang=ts"

import "./OrderItemRow.vue?vue&type=style&index=0&id=6b59a93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b59a93c"]])

export default __exports__